// extracted by mini-css-extract-plugin
export default {"body":"overview_body__+tokz","topbar":"overview_topbar__BGfM2","strong":"overview_strong__CRH3Z"};